import type { MultisigProposalStatus } from '@/api'
import { cn } from '@/theme/utils'

type Props = {
  status: MultisigProposalStatus
  className?: string
}

const statusChipClassNameMap: Record<MultisigProposalStatus, string> = {
  SUBMITTED: 'chip-gradient',
  ACCEPTED: 'chip-gradient-teal',
  REJECTED: 'chip-gradient-destructive',
  EXECUTED: 'chip-gradient-teal',
  FAILED: 'chip-gradient-destructive',
}

export default function ProposalStatusBadge({ status, className }: Props) {
  return (
    <div
      className={cn(
        'inline-flex h-7 items-center rounded-full px-3',
        'text-xs font-semibold',
        'backdrop-blur-md',
        statusChipClassNameMap[status],
        className,
      )}
    >
      {status}
    </div>
  )
}
